//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinComponent from './mixinComponent.js'
export default {
  name: 'VyInputRadio',
  mixins: [mixinComponent],
  props: {
    value: [String, Number, Array], // value需要双向绑定传递到组件外部
    text: String, // text需要双向绑定传递到组件外部

    title: String, // 标题
    placeholder: {type: String, default: '请选择'}, // 占位提示文字
    required: {type: Boolean, default: false}, // 必填
    readonly: {type: Boolean, default: false}, // 只读
    disabled: {type: Boolean, default: false}, // 禁用
    hide: {type: Boolean, default: false}, // 隐藏
  },
  data () {
    return {
      pickList: [{key: true, label: '是'}, {key: false, label: '否'}], // 选项列表
    }
  },
  computed: {
    currentValue: {
      get () { return this.value },
      set (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    cellClick () {
      if(!this.disabled && !this.readonly) {
        let currentValue = !this.currentValue
        this.currentValue = currentValue
        let label
        for(let item of this.pickList) {
          if(currentValue === item.key) {
            label = item.label
            break
          }
        }
        this.$emit('update:text', label)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputRadio.vue